import { FormikErrors } from 'formik'
import i18next from 'i18next'

import { biggerThanZero, onlyNumber } from '../../_utils/formValidators'

export const validateCheckBox = (informedTermsAndConditions: boolean) => {
  return (
    onlyNumber.default(Number(informedTermsAndConditions)) ||
    biggerThanZero.default(Number(informedTermsAndConditions))
  )
}

export const validateFieldForm = (informedTermsAndConditions: boolean) => {
  let errors: FormikErrors<{ informedTermsAndConditions: boolean }> = {}

  if (validateCheckBox(informedTermsAndConditions)) {
    errors.informedTermsAndConditions = i18next.t('validator.termsSelected')
  }

  return errors
}
